//package Import
import React, { useEffect, useState, useRef } from "react";

//component import
import Modal from 'react-bootstrap/Modal';

const OrderRequestViewModal = (props) => {
    const { close, open, data, valueDetails, userId, heading } = props;
    const modalRef = useRef();
    //function for handle modal backDrop Click
    const handleBackdropClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            // Handle the click outside the modal (e.g., prevent closing the modal)
            e.preventDefault();
            e.stopPropagation();
        }
    };
   
    //function call to close modal
    const handleOnclose = () => {
        close()
    }

    return (
        <Modal show={open} onHide={handleOnclose} aria-labelledby="contained-modal-title-vcenter"
            centered size={"md"} data-bs-theme="dark" backdrop="static" onClick={handleBackdropClick} >
            <div>
                <Modal.Header style={{ backgroundColor: "#0A2FB6" }} closeButton>
                    <h6 class="text-white fw-bold m-0 montserrat" >{props?.heading}</h6>
                </Modal.Header>

            </div>
            {
                props?.from === "orderRequest" ?
                    <div class="d-flex flex-row justify-content-center align-items-center">

                        <div class="w-100 p-3">
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Name </h6>
                                <h6 class="w-75">:  {data?.name} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Phone Number </h6>
                                <h6 class="w-75">:  {data?.phone_number} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Amount </h6>
                                <h6 class="w-75">:  ₹{data?.buy_amount !== 0 ? data?.buy_amount : 0} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Shares </h6>
                                <h6 class="w-75">: {data?.sell_shares !== 0 ? data?.sell_shares : 0} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Message </h6>
                                <h6 class="w-75 text-break">: {data?.message} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Status  </h6>
                                <h6 class="w-75">: {data?.approved !== null ? "Approved" : "Pending"} </h6>
                            </div>
                        </div>
                    </div>
                    :
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <div class="w-100 p-3">
                       
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Name </h6>
                                <span class="mx-1"></span>
                                <h6 class="w-100 m-0"> : {data?.name} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Email </h6>
                                <span class="mx-1"></span>
                                <h6 class="w-100 text-break m-0">: {data?.email} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50">Phone Number</h6>
                                <span class="mx-1"></span>
                                <h6 class="w-100 m-0">:  {data?.mobile} </h6>
                            </div>
                            {
                                
                                 data?.amount_invested === 0  || data?.amount_invested === null ?
                                    null
                                    :
                                    <div class="d-flex flex-row">
                                    <h6 class="w-50">Amount </h6>
                                    <span class="mx-1"></span>
                                    <h6 class="w-100 m-0">:  ₹{data?.amount_invested !== null ? data?.amount_invested : 0} </h6>
                                </div>
                            }
                                
                              {
                                
                                (data?.service === "undefined" || data?.service === ""  || data?.service === null  ) ?
                                   null
                                   :
                                   <div class="d-flex flex-row">
                                   <h6 class="w-50">Service </h6>
                                   <span class="mx-1"></span>
                                   <h6 class="w-100 m-0">: {data?.service !== null ? data?.service : "-"} </h6>
                               </div>
                           }

                            <div class="d-flex flex-row">
                                <h6 class="w-50">State</h6>
                                <span class="mx-1"></span>
                                <h6 class="w-100 m-0"> : {data?.state} </h6>
                            </div>
                            <div class="d-flex flex-row">
                                <h6 class="w-50 ">Message </h6>
                                <span class="mx-1"></span>
                                <h6 class="w-100 text-break m-0">: {data?.message} </h6>
                            </div>
                        </div>


                    </div>

            }

        </Modal>
    )
}

export default OrderRequestViewModal